import Utils from '@/common/utils/utils';
import Constant from '../../common/constant/Constant';
import { CircularProgress, Dialog } from '@material-ui/core';
import { useState } from 'react';
import {
    downloadFileFromS3,
    getFileSizeDisplay,
    getLinkDownloadFileFromS3
} from '../common/FileUploaded';
import { PropTypes } from 'prop-types';

export const AttachFile = ({ file, detailTicket, isAlignLeft, chatPost, setIsShowPopupLogout }) => {
    const [openPreviewImage, setOpenPreviewImage] = useState(null);

    let fileNameClass = isAlignLeft ? 'file-upload-name' : 'file-upload-name--change';
    const content = file?.shortKey ? file.fileInfo.fileName : file.fileData.name;
    const lastDot = content?.lastIndexOf('.');
    let fileExtention = '';
    let fileName;
    if (content.substring(0, lastDot).length === 0) {
        fileName = content.length > 50 ? content.slice(0, 50) + '...' : content;
    } else {
        fileExtention = content.substring(lastDot + 1);
        fileName =
            content.substring(0, lastDot).length > 50
                ? content.substring(0, lastDot).slice(0, 50) + '...'
                : content.substring(0, lastDot) + '.';
    }

    const fileNameAndSize = `${fileName}${fileExtention} (${getFileSizeDisplay(
        file?.shortKey ? file.fileInfo.fileSize : file.fileData.size
    )})`;

    const chatPostData = file?.shortKey
        ? {
              fileUrl: file.fileInfo.fileUrl,
              id: file.originId,
              type: Constant.S3_FILE_TYPE.CHAT_POST_FILE,
              chatThreadType: chatPost.chatThreadType,
              sharedRange: chatPost.sharedRange,
              content: file.fileInfo.fileName
          }
        : null;

    const dataDownload = file?.shortKey
        ? Utils.isImageFile(file.fileInfo.fileName)
            ? getLinkDownloadFileFromS3(chatPostData, detailTicket)
            : null
        : file.localUrl;

    const imgThumbnailLink = file?.shortKey
        ? Utils.isImageFile(file.fileInfo.fileName)
            ? getLinkDownloadFileFromS3(
                  { ...chatPostData, thumbnailInfo: JSON.stringify(file.thumbnailInfo) },
                  detailTicket,
                  null,
                  Constant.ATTACH_FILE.VIEW_CHAT
              )
            : null
        : file.localUrl;

    return (
        <div>
            {Utils.isImageFile(file?.fileInfo?.fileName) ||
            Utils.isImageFile(file?.fileData?.name) ? (
                <div
                    className="container-img-chatthread"
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        opacity: file?.shortKey ? 1 : 0.5,
                        position: 'relative'
                    }}
                >
                    <img
                        onClick={() => setOpenPreviewImage(dataDownload)}
                        style={{ cursor: 'pointer', borderRadius: 10, objectFit: 'cover' }}
                        height={145}
                        width={145}
                        src={imgThumbnailLink}
                        alt=""
                    />
                    {!file?.shortKey && (
                        <CircularProgress
                            size={30}
                            style={{
                                position: 'absolute',
                                inset: 0,
                                margin: 'auto'
                            }}
                        />
                    )}
                </div>
            ) : (
                <div style={{ opacity: file?.shortKey ? 1 : 0.5, position: 'relative' }}>
                    <a
                        className={`${fileNameClass} file-upload-active`}
                        target="_blank"
                        download={content}
                        onClick={() => {
                            if (file?.shortKey) {
                                downloadFileFromS3(
                                    chatPostData,
                                    detailTicket,
                                    false,
                                    false,
                                    '',
                                    setIsShowPopupLogout
                                );
                            }
                        }}
                    >
                        {fileNameAndSize}
                    </a>
                    {!file?.shortKey && (
                        <CircularProgress
                            size={20}
                            style={{
                                position: 'absolute',
                                inset: 0,
                                margin: 'auto'
                            }}
                        />
                    )}
                </div>
            )}
            <Dialog
                open={!!openPreviewImage}
                onClose={() => setOpenPreviewImage(null)}
                maxWidth="md"
            >
                <img
                    alt=""
                    src={openPreviewImage}
                    style={{
                        maxWidth: '90vw',
                        maxHeight: '90vh',
                        objectFit: 'contain'
                    }}
                />
            </Dialog>
        </div>
    );
};

AttachFile.propTypes = {
    file: PropTypes.any,
    detailTicket: PropTypes.any,
    isAlignLeft: PropTypes.any,
    chatPost: PropTypes.any,
    setIsShowPopupLogout: PropTypes.any
};
